import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { TOAST_DURATION } from 'src/app/config/global.config';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private notificationService: NotificationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        const errorsOrMessage = this.getErrorsOrMessage(error.error);
        let duration = Infinity;

        if (typeof errorsOrMessage === 'string') {
          duration = TOAST_DURATION;
        }

        this.notificationService.show(errorsOrMessage, 'error', { duration });
        return throwError(() => error);
      })
    );
  }

  /**
   * Check if the request is for an asset (image, CSS, JS, etc.)
   */
  isAssetRequest(url: string): boolean {
    const assetExtensions = [
      '.png',
      '.jpg',
      '.jpeg',
      '.gif',
      '.svg',
      '.ico',
      '.webp',
      '.css',
      '.js',
      '.woff',
      '.woff2',
      '.ttf',
      '.eot',
      '.mp4',
      '.webm',
      '.ogg',
      '.mp3',
      '.wav',
      '.json',
      '.xml',
      '.txt',
    ];

    // Check if URL contains asset extensions
    if (assetExtensions.some((ext) => url.toLowerCase().includes(ext))) {
      return true;
    }

    // Check if URL is for assets folder
    if (url.includes('/assets/') || url.includes('./assets/')) {
      return true;
    }

    // Check if URL is for i18n files
    if (url.includes('/i18n/')) {
      return true;
    }

    return false;
  }

  getErrorsOrMessage(error: any) {
    let errorsOrMessage = null;
    if (error?.error && Array.isArray(error?.error) && error?.error.length)
      // Return Validation Errors
      errorsOrMessage = error?.error?.map((err: any) => err.error);
    else if (typeof error?.error === 'string') {
      // Return the string error message directly
      errorsOrMessage = error.error;
    } else if (error.message)
      // Return message if no errors are present
      errorsOrMessage = error.message;
    // Provide a more user-friendly fallback message
    else
      errorsOrMessage = 'An unexpected error occurred. Please try again later or contact support.';

    return errorsOrMessage;
  }
}
